import SignIn from "../components/Login";
import brandLogo from "./../assets/brand.png";

const Login = () => {
  return (
    <div style={{
      display: "flex",
      minHeight: "100vh",
      backgroundColor: "#f8f9fa",
    }}>
      {/* Left branding panel */}
      <div style={{
        flex: "0 0 45%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "48px",
        backgroundColor: "#fff",
        borderRight: "1px solid #e9ecef",
      }}>
        <img src={brandLogo} alt="Verto" style={{ width: 160, marginBottom: 32 }} />
        <p style={{
          color: "#868e96",
          fontSize: 15,
          lineHeight: 1.7,
          maxWidth: 300,
          textAlign: "center",
          margin: 0,
        }}>
          Transparent commodity traceability powered by blockchain technology.
        </p>
      </div>

      {/* Right form panel */}
      <div style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 24px",
        backgroundColor: "#f8f9fa",
      }}>
        <SignIn />
      </div>
    </div>
  );
};

export default Login;
